import React from "react";

import { OrgModLink } from "src/features/orgmod";
import { usePatientIdParam } from "src/features/patient/hooks";

type PatientLinkProps = React.ComponentProps<typeof OrgModLink>;

export const PatientLink: React.FunctionComponent<PatientLinkProps> = ({
	to,
	...props
}) => {
	const patientId = usePatientIdParam();
	return (
		<OrgModLink
			to={`/patients/${patientId}/${to.replace(/^\//, "")}`}
			{...props}
		/>
	);
};
